export const PASSWORD_REGEX = process.env.REACT_APP_PASSWORD_REGEX;
export const EMAIL_REGEX =
  /([!#-'*+\/-9=?A-Z^-~-]+(.[!#-'*+\/-9=?A-Z^-~-]+)*|"([]!#-[^-~ \t]|(\[\t -~]))+")@([!#-'*+\/-9=?A-Z^-~-]+(.[!#-'*+\/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])/;

export const isEmpty = (val) => {
  return val === '' || val === null || val === undefined;
};

export const isFalse = (val) => val === false;

export const minMax = (val, min, max) => {
  return val.length >= min && val.length <= max;
};

export const isEmail = (val) => {
  return EMAIL_REGEX.test(val);
};

export const isPasswordValid = (val) => {
  return new RegExp(PASSWORD_REGEX).test(val);
};

export const passwordsAreEquals = (password, confirmPassword) => {
  return password === confirmPassword;
};
